import qs from 'qs'
import axios from 'axios'

const service = axios.create({
    baseURL: 'http://api.royalacg.com/api',
    // baseURL: 'http://47.108.238.247:31101/api',
    // baseURL: 'http://172.28.153.223:82/api',
    timeout: 3000,
    headers: {
        'Content-Type': 'application/json',
    },
})

service.interceptors.request.use((config) => {
    if (config.method == 'post') {
        config.data = qs.stringify(config.data)
    }
    return config
})

service.interceptors.response.use((response) => {
    const res = response.data

    const { code, data, message } = res

    if (code == 200) {
        return Promise.resolve(data)
    }

    return Promise.reject(new Error(message))
})

export default service
